<template>
  <b-dropdown
    :style="[
      {
        fontFamily: this.family,
        fontSize: '12px',
        textOverflow: 'ellipsis'
      }
    ]"
    :disabled="this.disabled"
    variant="outline-primary"
    class="font-type"
  >
    <template slot="button-content">
      {{ this.fontFamily | findName(this.family) | truncate(7) }}
    </template>
    <b-dropdown-item
      class="overflow-auto"
      v-for="fm in this.fontFamily"
      :key="fm.name"
      :active="family === fm.family"
      :style="[{ fontFamily: fm.family, fontSize: '11px' }]"
      @click.prevent="fontFamilyClick(fm.family)"
      >{{ fm.name }}</b-dropdown-item
    >
  </b-dropdown>
</template>

<script>
import { ActionType } from './actionType'
export default {
  props: {
    fontValue: {
      type: String,
      default: 'Arial, Helvetica, sans-serif'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.family = this.fontValue
  },
  data () {
    return {
      actionType: ActionType.FONT_FAMILY,
      fontFamily: [
        { name: 'Arial', family: 'Arial, Helvetica, sans-serif', state: true },
        { name: 'Arial Black', family: '"Arial Black", Gadget, sans-serif', state: false },
        { name: 'Impact', family: 'impactregular', state: false },
        { name: 'Comic Sans MS', family: '"Comic Sans MS", cursive, sans-serif', state: false },
        { name: 'Courier New', family: '"Courier New", Courier, monospace', state: false },
        { name: 'Georgia', family: 'Georgia, serif', state: false },
        { name: 'Lucida Console', family: '"Lucida Console", Monaco, monospace', state: false },
        { name: 'Lucida Sans Unicode', family: '"Lucida Sans Unicode", "Lucida Grande", sans-serif', state: false },
        { name: 'Open Sans', family: '"Open sans", Arial, sans-serif', state: false },
        { name: 'Palatino Linotype', family: '"Palatino Linotype", "Book Antiqua", Palatino, serif', state: false },
        { name: 'Tahoma', family: 'Tahoma, Geneva, sans-serif', state: false },
        { name: 'Times New Roman', family: '"Times New Roman", Times, serif', state: false },
        { name: 'Trebuchet MS', family: '"Trebuchet MS", Helvetica, sans-serif', state: false },
        { name: 'Verdana', family: 'Verdana, Geneva, sans-serif', state: false },
        { name: 'Corbel', family: 'Corbel', state: false },
        { name: 'Calibri', family: 'Calibri', state: false },
        { name: 'Lucida Sans', family: 'Lucida Sans', state: false },
        { name: 'Agency FB', family: 'Agency FB', state: false },
        { name: 'Berlin Sans FB', family: 'Berlin Sans FB', state: false },
        { name: 'Book Antiqua', family: 'Book Antiqua', state: false },
        { name: 'Century', family: 'Century', state: false },
        { name: 'Century Gothic', family: 'Century Gothic', state: false },
        { name: 'Bell MT', family: 'Bell MT', state: false },
        { name: 'Franklin Gothic Book', family: 'Franklin Gothic Book', state: false },
        { name: 'Candara', family: 'Candara', state: false },
        { name: 'Bookman Old Style', family: 'Bookman Old Style', state: false },
        { name: 'Impacted', family: 'Impacted', state: false },
        { name: 'Arial Narrow', family: 'Arial Narrow', state: false },
        { name: 'Gill Sans', family: 'Gill Sans', state: false },
        { name: 'Avenir Next LT Pro', family: 'Avenir Next LT Pro', state: false }
      ],
      family: 'Arial'
    }
  },
  methods: {
    fontFamilyClick (value) {
      this.family = value
      this.$emit('change', this.actionType, value)
    }
  },
  filters: {
    truncate: function (text, length) {
      return (text.length > length) ? text.substring(0, length) + ' ...' : text
    },
    findName: function (array, keyword) {
      return array.find(el => el.family === keyword || el.name === keyword).name
    }
  }
}
</script>

<style lang="scss">
  .font-type{
    button {
      width: '100px';
      &.dropdown-toggle{
        width: 100px;
        overflow: hidden;
        padding-right: 10px;
      }
    }
    ul {
      height: 250px;
      overflow-y: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/ui/fontFamilyUI.vue